<main class="min-h-screen flex flex-col" role="main">
  <neopos-navbar />

  <div class="min-h-full overflow-x-hidden">
    <router-outlet />
  </div>

  <neopos-footer class="mt-auto" />
</main>
